// extracted by mini-css-extract-plugin
export default {"button":"CollapsibleTitle_button__VfSc9","text":"CollapsibleTitle_text__8OD1q"};